export function demandSettingsTarget(expected, actual) {
  const pairs = [[expected?.deviceId, actual?.deviceId], [expected?.hardwareUid, actual?.hardwareUid],
    [expected?.profileId ?? expected?.hardwareProfile, actual?.profileId ?? actual?.hardwareProfile]];
  if (pairs.some(([a, b]) => typeof a !== "string" || !a.trim() || typeof b !== "string" || a.toLowerCase() !== b.toLowerCase()))
    throw new Error("The connected Pirdy does not match this device's settings. No settings were changed.");
}
